import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage, useField } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import currencyOptions from '../../../common/data/currency-new.json';
import SafeField from "helpers/SafeField";

const CurrencyDropdown = ({ name, label, onCurrencyChange, ...props }) => {
  const [options, setOptions] = useState([]);
  const [field, meta] = useField(name);

  useEffect(() => {
    const optionsArray = Object.keys(currencyOptions).map((key) => ({
      id: key,
      name: currencyOptions[key].name,
      //symbol: currencyOptions[key].symbol,
      //locale: currencyOptions[key].locale, 
    }));
    setOptions(optionsArray);
  }, []);

  const handleCurrencyChange = (event) => {
    const selectedCurrencyId = event.target.value;
    const selectedCurrencyObj = currencyOptions[selectedCurrencyId];

    if (onCurrencyChange) {
      onCurrencyChange({
        code: selectedCurrencyId,  
        //symbol: selectedCurrencyObj.symbol,
        //locale: selectedCurrencyObj.locale,
        currency: selectedCurrencyObj.name
      });
    }
  };

  return (
    <FormGroup className="mb-3">
      <Label htmlFor={name}>{label} *</Label>
      <SafeField
        as="select"
        name={name}
        className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
        onChange={(event) => {
          field.onChange(event);
          handleCurrencyChange(event); 
        }}
        value={field.value || ''} 
        {...props}
      >
        <option value="">Select</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name + " - " + option.id}
          </option>
        ))}
      </SafeField>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </FormGroup>
  );
};

CurrencyDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onCurrencyChange: PropTypes.func, 
};

CurrencyDropdown.defaultProps = {
  onCurrencyChange: () => {}, 
};

export default CurrencyDropdown;
